export const VIEW_BREAKPOINTS = Object.freeze({
    XS: 575.98,
    MOBILE: 767.98,
    TABLET: 991.98,
    LG: 1199.98,
});

export default {
    data() {
        return {
            windowWidth: window.innerWidth,
        };
    },
    computed: {
        isXs() {
          return this.windowWidth <= VIEW_BREAKPOINTS.XS;
        },
        isMobile() {
            return this.windowWidth <= VIEW_BREAKPOINTS.MOBILE;
        },
        isTablet() {
            return this.windowWidth > VIEW_BREAKPOINTS.MOBILE && this.windowWidth <= VIEW_BREAKPOINTS.TABLET;
        },
        isDesktop() {
            return this.windowWidth > VIEW_BREAKPOINTS.TABLET;
        },
        isLargeDesktop() {
            return this.windowWidth >= VIEW_BREAKPOINTS.LG;
        },
    },
    beforeMount() {
        window.addEventListener('resize', this.setWindowWidth);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.setWindowWidth);
    },
    methods: {
        setWindowWidth() {
            this.windowWidth = window.innerWidth;
        }
    }
};
